"use strict";

import {
    domElementExistByQuery
} from './commons/domCheck.js';


import {
    endYoutubeVideo
} from './commons/youtube.js';

document.addEventListener('DOMContentLoaded', () => {

    const notLogedWarning = document.getElementById('notLogedWarning');
    if (domElementExistByQuery("#script-bootcamp-logueado") && (Flickity != undefined || Flickity != null)) {
        const isLogedUser = (document.getElementById('isLogedUser').innerHTML.includes(false)) ? false : true;
        if (isLogedUser) {
            const menuUserEmail = document.querySelector('#user-menu span').innerHTML;
            const url = document.getElementById("adminUrl").innerHTML;
            const getTemplateDirectory = document.getElementById('getTemplateDirectory').innerHTML;

            const modules = [
                {
                    moduleTitle: 'Certificación en Automation Marketing',
                    title: '',
                    content: '',
                    contentAfter: '',
                    contentFinal: '',
                    currentPercentage: 0,
                    speakers: [
                        ` `
                    ],
                    showModule: false,
                    resourse: '',
                    videosAmount: 1
                },
                {
                    moduleTitle: 'Módulo 1. Fase de Adquisición',
                    title: '¡Has finalizado el <b>Módulo 1</b>!',
                    content: 'Te esperamos el 9 de junio para completar el siguiente módulo :)',
                    contentAfter: 'Esperamos que lo hayas disfrutado :) Si quieres avanzar con el Bootcamp, haz clic en “siguiente video” y comienza con el Módulo 02: Fase de Nutrición',
                    contentFinal: 'Para guardar todo tu progreso y obtener tu certificado de asistencia, haz clic en el siguiente botón.',
                    currentPercentage: 0,
                    speakers: [
                        `
  <h3>Este Módulo está dictado por:</h3>
                <ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--mb main-carousel" >
                    <li class="pageBootcampModules__content__description__list__item carousel-cell">
                        <figure><img src="${getTemplateDirectory}/img/mery.png" alt="María Díaz"></figure>
                        <figcaption>
                            <h4>María Díaz</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
                            <p>PR & Events Manager en Doppler</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
                        </figcaption>
                    </li>
                    <li class="pageBootcampModules__content__description__list__item carousel-cell">
                        <figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
                        <figcaption>
                            <h4>Ennio Castillo</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
                            <p>Partners & Integrations Manager en Doppler.</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
                        </figcaption>
                    </li>
                    <li class="pageBootcampModules__content__description__list__item carousel-cell">
                        <figure><img src="${getTemplateDirectory}/img/beatriz-moure-g.png" alt="Beatriz Moure"></figure>
                        <figcaption>
                            <h4>Beatriz Moure</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                            <p>Consultora de Email Marketing</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                        </figcaption>
                    </li>
                    <li class="pageBootcampModules__content__description__list__item carousel-cell">
                        <figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
                        <figcaption>
                            <h4>Car Bianchi</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
                            <p>Customer Support Representative en Doppler</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
                        </figcaption>
                    </li>
                </ul>

                <ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--dk">
                    <li class="pageBootcampModules__content__description__list__item">
                        <figure><img src="${getTemplateDirectory}/img/mery.png" alt="María Díaz"></figure>
                        <figcaption>
                            <h4>María Díaz</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
                            <p>PR & Events Manager en Doppler</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
                        </figcaption>
                    </li>
                    <li class="pageBootcampModules__content__description__list__item">
                        <figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
                        <figcaption>
                            <h4>Ennio Castillo</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
                            <p>Partners & Integrations Manager en Doppler.</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
                        </figcaption>
                    </li>
                    <li class="pageBootcampModules__content__description__list__item">
                        <figure><img src="${getTemplateDirectory}/img/beatriz-moure-g.png" alt="Beatriz Moure"></figure>
                        <figcaption>
                            <h4>Beatriz Moure</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                            <p>Consultora de Email Marketing</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                        </figcaption>
                    </li>
                    <li class="pageBootcampModules__content__description__list__item">
                        <figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
                        <figcaption>
                            <h4>Car Bianchi</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
                            <p>Customer Support Representative en Doppler</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
                        </figcaption>
                    </li>
                </ul>
`
                    ],
                    showModule: false,
                    resourse: '<p>En este módulo te recomendamos esta lectura para complementar tu aprendizaje: <a target="_blank" href="https://www.fromdoppler.com/es/recursos-marketing/?utm_source=fromdoppler&utm_medium=partners&utm_campaign=inbound-bootcamp/&recurso=segmentacion-email-marketing#infografias">Segmentación en Email Marketing.</a></p>',
                    videosAmount: 4
                },
                {
                    moduleTitle: 'Módulo 2: Fase de Nutrición',
                    title: '¡Has finalizado el <b>Módulo 2</b>!',
                    content: 'Te esperamos el 16 de junio para completar el siguiente módulo :)',
                    contentAfter: 'Esperamos que lo hayas disfrutado :) Si quieres avanzar con el Bootcamp, haz clic en “siguiente video” y comienza con el Módulo 02: Fase de Conversión',
                    contentFinal: 'Para guardar todo tu progreso y obtener tu certificado de asistencia, haz clic en el siguiente botón.',
                    currentPercentage: 0,
                    speakers: [
                        `
<h3>Este Módulo está dictado por:</h3>
<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--mb main-carousel" >
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/samuel-chavez-g.png" alt="Samuel Chavez"></figure>
	<figcaption>
		<h4>Samuel Chavez</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
		<p>Chief Growth Officer en EnveraMx</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
	<figcaption>
		<h4>Ennio Castillo</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
		<p>Partners & Integrations Manager en Doppler.</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>
</ul>

<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--dk">
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/samuel-chavez-g.png" alt="Samuel Chavez"></figure>
	<figcaption>
		<h4>Samuel Chavez</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
		<p>Chief Growth Officer en EnveraMx</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
	<figcaption>
		<h4>Ennio Castillo</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
		<p>Partners & Integrations Manager en Doppler.</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>
</ul>
`
                    ],
                    showModule: false,
                    resourse: '<p>En este módulo te recomendamos esta lectura para complementar tu aprendizaje: <a target="_blank" href="https://www.fromdoppler.com/es/recursos-marketing/?utm_source=fromdoppler&utm_medium=partners&utm_campaign=inbound-bootcamp&recurso=formula-generar-clientes#ebooks">El secreto para generar Leads: cómo atraer visitantes y convertirlos utilizando el poder de las Landing Pages.</a></p>',
                    videosAmount: 4
                }
                ,
                {
                    moduleTitle: 'Módulo 3 - Fase de Conversión',
                    title: '¡Has finalizado el <b>Módulo 3</b>!',
                    content: 'Te esperamos el 23 de junio para completar el siguiente módulo :)',
                    contentAfter: 'Esperamos que lo hayas disfrutado :) Si quieres avanzar con el Bootcamp, haz clic en “siguiente video” y comienza con el Módulo 02: Fase de Conversión',
                    contentFinal: 'Para guardar todo tu progreso y obtener tu certificado de asistencia, haz clic en el siguiente botón.',
                    currentPercentage: 0,
                    speakers: [
                        `
<h3>Este Módulo está dictado por:</h3>
<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--mb main-carousel" >
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/mery.png" alt="María Díaz"></figure>
	<figcaption>
		<h4>María Díaz</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
		<p>PR & Events Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/paco-vargas-g.png" alt="Paco Vargas"></figure>
	<figcaption>
		<h4>Paco Vargas</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
		<p>Consultor de Social Media e Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
	<figcaption>
		<h4>Car Bianchi</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
		<p>Customer Support Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
	</figcaption>
</li>
</ul>

<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--dk">
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/mery.png" alt="María Díaz"></figure>
	<figcaption>
		<h4>María Díaz</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
		<p>PR & Events Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/paco-vargas-g.png" alt="Paco Vargas"></figure>
	<figcaption>
		<h4>Paco Vargas</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
		<p>Consultor de Social Media e Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
	<figcaption>
		<h4>Car Bianchi</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
		<p>Customer Support Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
	</figcaption>
</li>
</ul>
`
                    ],
                    showModule: false,
                    resourse: '<p>En este módulo te recomendamos esta lectura para complementar tu aprendizaje: <a target="_blank" href="https://www.fromdoppler.com/es/recursos-marketing/?utm_source=fromdoppler&utm_medium=partners&utm_campaign=inbound-bootcamp&recurso=ebook-email-automation#ebooks">Multiplica tus ventas con Email Automation.</a></p>',
                    videosAmount: 4
                }
                ,
                {
                    moduleTitle: 'Módulo 4 - Fase de Retención',
                    title: '¡Has finalizado el <b>Módulo 4</b>!',
                    content: 'Te esperamos el 30 de junio para completar el siguiente módulo :)',
                    contentAfter: 'Esperamos que lo hayas disfrutado :) Si quieres avanzar con el Bootcamp, haz clic en “siguiente video” y comienza con el Módulo 02: Fase de Conversión',
                    contentFinal: 'Para guardar todo tu progreso y obtener tu certificado de asistencia, haz clic en el siguiente botón.',
                    currentPercentage: 0,
                    speakers: [
                        `
<h3>Este Módulo está dictado por:</h3>
<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--mb main-carousel" >
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
	<figcaption>
		<h4>Ennio Castillo</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
		<p>Partners & Integrations Manager en Doppler.</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/humberto-amador-g.png" alt="Humberto Amador"></figure>
	<figcaption>
		<h4>Humberto Amador</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
		<p>Consultor en Estrategias de Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>
</ul>

<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--dk">
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
	<figcaption>
		<h4>Ennio Castillo</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
		<p>Partners & Integrations Manager en Doppler.</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/humberto-amador-g.png" alt="Humberto Amador"></figure>
	<figcaption>
		<h4>Humberto Amador</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
		<p>Consultor en Estrategias de Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>
</ul>
`
                    ],
                    showModule: false,
                    resourse: '<p>En este módulo te recomendamos esta lectura para complementar tu aprendizaje: <a target="_blank" href="https://www.fromdoppler.com/es/recursos-marketing/?utm_source=fromdoppler&utm_medium=partners&utm_campaign=inbound-bootcamp&recurso=ebook-inbound#ebooks">Inbound Marketing: Capta nuevos clientes sin esfuerzo.</a></p>',
                    videosAmount: 4
                }
                ,
                {
                    moduleTitle: 'Módulo 5 - Fase de Recompra',

                    title: '¡Has terminado la <b>Certificación en Automation Marketing</b>!',
                    content: 'Esperamos que lo hayas disfrutado :)',
                    contentAfter: 'Esperamos que lo hayas disfrutado :) Si quieres avanzar con el Bootcamp, haz clic en “siguiente video” y comienza con el Módulo 02: Fase de Conversión',
                    contentFinal: 'Para obtener tu certificado, haz clic en el siguiente botón:',
                    currentPercentage: 0,
                    speakers: [
                        `
<h3>Este Módulo está dictado por:</h3>
<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--mb main-carousel" >
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/monica-franco-g.png" alt="Mónica Franco"></figure>
	<figcaption>
		<h4>Mónica Franco</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
		<p>Marketing Digital & Advertising</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
	<figcaption>
		<h4>Car Bianchi</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
		<p>Customer Support Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
	</figcaption>
</li>
</ul>

<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--dk">
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/monica-franco-g.png" alt="Mónica Franco"></figure>
	<figcaption>
		<h4>Mónica Franco</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
		<p>Marketing Digital & Advertising</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>
<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
	<figcaption>
		<h4>Car Bianchi</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
		<p>Customer Support Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
	</figcaption>
</li>
</ul>
`
                    ],
                    showModule: false,
                    resourse: '<p>En este módulo te recomendamos esta lectura para complementar tu aprendizaje: <a target="_blank" href="https://www.fromdoppler.com/es/recursos-marketing/?utm_source=fromdoppler&utm_medium=partners&utm_campaign=inbound-bootcamp&recurso=Email-Automation-E-commerce#ebooks">E-book para aplicar Email Automation en tu E-commerce</a></p>',
                    videosAmount: 4
                }
            ];
            const allSpeakersDomElements = `
<h3>Nos acompañaron en este Bootcamp:</h3>
<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--mb main-carousel" >

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
	<figcaption>
		<h4>Ennio Castillo</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
		<p>Partners & Integrations Manager en Doppler.</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
	<figcaption>
		<h4>Car Bianchi</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
		<p>Customer Support Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/mery.png" alt="María Díaz"></figure>
	<figcaption>
		<h4>María Díaz</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
		<p>PR & Events Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
	</figcaption>
</li>

     <li class="pageBootcampModules__content__description__list__item carousel-cell">
                        <figure><img src="${getTemplateDirectory}/img/beatriz-moure-g.png" alt="Beatriz Moure"></figure>
                        <figcaption>
                            <h4>Beatriz Moure</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                            <p>Consultora de Email Marketing</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                        </figcaption>
                    </li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/samuel-chavez-g.png" alt="Samuel Chavez"></figure>
	<figcaption>
		<h4>Samuel Chavez</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
		<p>Chief Growth Officer en EnveraMx</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/paco-vargas-g.png" alt="Paco Vargas"></figure>
	<figcaption>
		<h4>Paco Vargas</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
		<p>Consultor de Social Media e Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/humberto-amador-g.png" alt="Humberto Amador"></figure>
	<figcaption>
		<h4>Humberto Amador</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
		<p>Consultor en Estrategias de Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item carousel-cell">
	<figure><img src="${getTemplateDirectory}/img/monica-franco-g.png" alt="Mónica Franco"></figure>
	<figcaption>
		<h4>Mónica Franco</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
		<p>Marketing Digital & Advertising</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
	</figcaption>
</li>
</ul>

<ul class="pageBootcampModules__content__description__list pageBootcampModules__content__description__list--dk">

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/ennio.png" alt="Ennio Castillo"></figure>
	<figcaption>
		<h4>Ennio Castillo</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
		<p>Partners & Integrations Manager en Doppler.</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/castilloennio/ " target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/facu.png" alt="Facundo Mazza"></figure>
	<figcaption>
		<h4>Facundo Mazza</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
		<p>Regional Marketing Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/facundomazza/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/lucia.png" alt="Lucía Rubini"></figure>
	<figcaption>
		<h4>Lucía Rubini</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
		<p>Customer Success Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/lucia-rubini-405200149/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/carla.png" alt="Car Bianchi"></figure>
	<figcaption>
		<h4>Car Bianchi</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
		<p>Customer Support Representative en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/carla-antonela-bianchi-b7b34815/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/mery.png" alt="María Díaz"></figure>
	<figcaption>
		<h4>María Díaz</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
		<p>PR & Events Manager en Doppler</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/mariajudithdiaz/" target="_blank"></a>
	</figcaption>
</li>

     <li class="pageBootcampModules__content__description__list__item">
                        <figure><img src="${getTemplateDirectory}/img/beatriz-moure-g.png" alt="Beatriz Moure"></figure>
                        <figcaption>
                            <h4>Beatriz Moure</h4>
                            <a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                            <p>Consultora de Email Marketing</p>
                            <a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/beatrizmoure/" target="_blank"></a>
                        </figcaption>
                    </li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/samuel-chavez-g.png" alt="Samuel Chavez"></figure>
	<figcaption>
		<h4>Samuel Chavez</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
		<p>Chief Growth Officer en EnveraMx</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/samuelchav3z/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/paco-vargas-g.png" alt="Paco Vargas"></figure>
	<figcaption>
		<h4>Paco Vargas</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
		<p>Consultor de Social Media e Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/franciscovargassalazar/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/humberto-amador-g.png" alt="Humberto Amador"></figure>
	<figcaption>
		<h4>Humberto Amador</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
		<p>Consultor en Estrategias de Email Marketing</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/humbertoap/" target="_blank"></a>
	</figcaption>
</li>

<li class="pageBootcampModules__content__description__list__item">
	<figure><img src="${getTemplateDirectory}/img/monica-franco-g.png" alt="Mónica Franco"></figure>
	<figcaption>
		<h4>Mónica Franco</h4>
		<a class="pageBootcampModules__content__description--mb" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
		<p>Marketing Digital & Advertising</p>
		<a class="pageBootcampModules__content__description--dk" href="https://www.linkedin.com/in/m%C3%B3nica-franco/" target="_blank"></a>
	</figcaption>
</li>
</ul>
			`
            const totalModules = document.querySelectorAll('.module');
            const loaderPage = document.getElementById('loader-page');
            const certificateForm = document.getElementById('certificateForm');
            const nextVideoBaner = document.getElementById('nextVideoBanner');
            const allLiVideos = document.querySelectorAll('.content-list .module li');

            var userEndBootcamp = false;
            var currentModule;
            var currentVideo;
            // Checkeamos el ultimo modulo visto por el usuario

            loaderPage.classList.add('visible');

            const _deleteElementById = (id) => {
                // Removemos el boton que se genera al terminarlo
                if (document.getElementById(id) != null) {
                    document.getElementById(id).remove();
                };
            };

            const _generateFlickity = () => {
                // Funcion externa para el carrousel
                var elem = document.querySelector('.main-carousel');
                var flkty = new Flickity(elem, {
                    // options
                    autoPlay: true,
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    fade: true,
                    wrapAround: true
                });
                setTimeout(() => {
                    flkty.reloadCells();
                }, 1000)


            }

            const getLastView = async () => {
                const formData = new FormData();
                formData.append('action', 'get_last_bootcamp_views_by_email');
                formData.append('email', menuUserEmail);

                const response = await fetch(url, {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                });
                const lastView = await response.json();
                return (lastView === null) ? { module: 0 } : lastView;
            };

            getLastView().then(({ module }) => {
                const lastView = module;
                if (module != 0) {
                    currentModule = lastView.match(/modulo/);
                    currentVideo = lastView.match(/video/);
                    currentModule = lastView.substring(currentModule.index);
                    currentVideo = lastView.substring(currentVideo.index);
                    currentModule = currentModule.match(/\d+/)[0];
                    currentVideo = currentVideo.match(/\d+/)[0];
                } else {
                    currentModule = 0;
                    currentVideo = 0;
                }

                userEndBootcamp = (currentModule == 5 && currentVideo == 4) ? true : false;
                setListeners();

                if (!userEndBootcamp) {
                    const nextData = checkCurrentModule(currentModule, currentVideo);
                    currentModule = nextData[0];
                    currentVideo = nextData[1];
                    setUserVideo(currentModule, currentVideo);
                } else {
                    setTextFrame();
                    setFrameButtons();
                }


                setMenuProperties(currentModule, currentVideo);
                setModulesProperties(currentModule);
                _generateFlickity();
                loaderPage.classList.remove('visible');

            });

            const checkCurrentModule = (currentModule, currentVideo) => {

                if (currentVideo < modules[currentModule].videosAmount) {
                    currentVideo++;
                } else {
                    currentModule++;
                    currentVideo = 1;
                }

                return [currentModule, currentVideo];
            }

            const setListeners = () => {
                const allVideoButtons = document.querySelectorAll('.btnVideoPoint');
                certificateForm.addEventListener('submit', submitCertificate)
                allVideoButtons.forEach(item => {
                    item.addEventListener('click', () => { changeVideo(item) });
                });
                allLiVideos.forEach(li => {
                    li.addEventListener('click', () => {
                        let liViewed = li.classList.contains('viewed');
                        if (liViewed) {
                            let liId = li.id;

                            _deleteElementById('certificateBtn');
                            _deleteElementById('backVideo');
                            currentModule = _searchInString(liId, 'modulo');
                            currentVideo = _searchInString(liId, 'video');
                            _hidenAllFrames();
                            setModuleTitle(currentModule);
                            setMenuPercentage(currentModule, currentVideo);
                            setUserVideo(currentModule, currentVideo);

                            if (!nextVideoBaner.classList.contains('noNextVideo')) {
                                nextVideoBaner.classList.add('noNextVideo');
                            }
                        }
                    });
                });
            }

            const _hidenAllFrames = () => {
                // Oculta todos los contenedores de frames
                const allFrames = document.querySelectorAll('.video-container');
                allFrames.forEach(frame => {
                    frame.classList.remove('showCurrentVideo');
                })
            }

            const setUserVideo = (currentModule, currentVideo) => {
                _hidenAllFrames();
                const currentFrame = document.getElementById(`video_bootcamp1_modulo${currentModule}_video${currentVideo}`);
                currentFrame.classList.add('showCurrentVideo');
            }

            const setMenuProgress = (currentModule, currentVideo) => {

                for (let module = 0; module <= currentModule; module++) {

                    let maxVideos = modules[currentModule].videosAmount;

                    if (module == currentModule) {
                        maxVideos = currentVideo;
                    } else if (module === 0) {
                        maxVideos = 1;
                    }

                    for (let video = 1; video <= maxVideos; video++) {
                        document.getElementById(`bootcamp1_modulo${module}_video${video}`).classList.add('viewed');
                    }

                }

                if (currentModule == 5 && currentVideo == 4) {
                    document.getElementById(`bootcamp1_modulo${currentModule}_video${currentVideo}`).classList.add('viewed');
                    document.getElementById(`bootcamp1_modulo${currentModule}_video${currentVideo}`).classList.remove('currentLi');
                }

            }

            const setMenuPercentage = (currentModule, currentVideo) => {

                totalModules.forEach((module, index) => {

                    let percentage = 0;
                    if (!userEndBootcamp) {
                        if (index < currentModule) {
                            percentage = 100;
                        } else if (index == currentModule) {
                            percentage = (currentModule == 5 && currentVideo == 4) ? 100 : ((currentVideo - 1) / modules[index].videosAmount) * 100;
                        } else {
                            percentage = 0;
                        }
                    } else {
                        percentage = 100;
                    }

                    modules[index].currentPercentage = userEndBootcamp ? 100 : percentage;
                    let moduleProgress = module.querySelector('.module-progress');
                    moduleProgress.style.width = percentage + '%';
                    let moduleProgressNumber = module.querySelector('.module-progress-number');
                    moduleProgressNumber.innerHTML = Math.trunc(percentage) + '%';

                });
            }

            const setMenuChecks = (currentModule) => {


                for (let i = 0; i < currentModule; i++) {
                    totalModules[i].querySelector('.pageBootcampModules__sidebar__module__head').classList.add('pageBootcampModules__sidebar__module__head--checkActive');
                }

                if (userEndBootcamp) {
                    totalModules[5].querySelector('.pageBootcampModules__sidebar__module__head').classList.add('pageBootcampModules__sidebar__module__head--checkActive');
                }

            }

            const setMenuCurrentLi = (currentModule, currentVideo) => {
                document.querySelectorAll('.content-list li').forEach(item => { item.classList.remove('currentLi'); });
                document.getElementById(`bootcamp1_modulo${currentModule}_video${currentVideo}`).classList.add('currentLi');
            }

            const setMenuProperties = (currentModule, currentVideo) => {
                setMenuCurrentLi(currentModule, currentVideo);
                setMenuProgress(currentModule, currentVideo);
                setMenuPercentage(currentModule, currentVideo);
                setMenuChecks(currentModule);
            }

            const setSpeakers = (currentModule) => {
                const speakerContainer = document.querySelector('.pageBootcampModules__content__description');

                if (userEndBootcamp) {
                    speakerContainer.innerHTML = allSpeakersDomElements;
                } else {
                    let speakers = modules[currentModule].speakers;
                    speakerContainer.innerHTML = speakers;
                }

            }

            const setModule = (currentModule) => {
                let titleModule = document.querySelector('.pageBootcampModules__content__title');
                totalModules.forEach(module => {
                    module.classList.remove('pageBootcampModules__sidebar__module--opened');
                    module.classList.add('pageBootcampModules__sidebar__module--close');
                });

                totalModules[currentModule].classList.add('pageBootcampModules__sidebar__module--opened');
                if (document.getElementById('certificateBtn') === null) {
                    titleModule.innerHTML = '';
                    titleModule.innerHTML = modules[currentModule].moduleTitle;
                }
            }

            const setResource = (currentModule) => {
                const pageBootcampModulesResources = document.querySelector('.pageBootcampModules__resources');

                if (userEndBootcamp) {
                    pageBootcampModulesResources.style.display = 'none';
                    document.querySelector('.pageBootcampModules__content__description').classList.add('description--mt');
                } else {
                    pageBootcampModulesResources.style.display = 'block';
                    document.querySelector('.pageBootcampModules__content__description').classList.remove('description--mt');
                    pageBootcampModulesResources.innerHTML = modules[currentModule].resourse;
                }
            }

            const setModulesProperties = (currentModule) => {
                setSpeakers(currentModule);
                setModule(currentModule);
                setResource(currentModule);
            }

            const _searchInString = (string, type) => {
                let fullModule = string.split('_').filter(string => string.includes(type));
                fullModule = fullModule.toString();
                let moduleNumber = fullModule.match(/\d+/)[0];
                return moduleNumber;
            }

            const setTextFrame = () => {
                const promocode = document.querySelector('.pageBootcampModules__promocode');
                const bootcampEnd = document.querySelector('.pageBootcampModules__bootcamp-end');
                const nextVideoBaner = document.getElementById('nextVideoBanner');
                const title = nextVideoBaner.querySelector('h2');
                const paragraph = nextVideoBaner.querySelector('p');
                const btn = document.createElement('button');
                const titleModule = document.querySelector('.pageBootcampModules__content__title');
                const boxButtons = document.getElementsByClassName('pageBootcampModules__content__videobanner__actions')[0];
                nextVideoBaner.classList.remove('noNextVideo');
                btn.classList.add('btnCertificado', 'dp-button', 'primary-green', 'button-medium', 'button--round');
                btn.innerHTML = 'DESCARGAR DIPLOMA'
                btn.id = 'certificateBtn'
                if (boxButtons.querySelector('#certificateBtn') === null) {
                    boxButtons.appendChild(btn);
                }
                btn.addEventListener('click', () => { document.querySelector('.modalCertificateContainer').classList.remove('ac-none'); });
                titleModule.innerHTML = 'Fin del Bootcamp :)';
                title.innerHTML = modules[5].title;;
                paragraph.innerHTML = modules[5].contentFinal;
                promocode.style.display = "block";
                bootcampEnd.style.display = "block";
            }


            const backLastVideo = () => {
                nextVideoBaner.classList.add('noNextVideo');
                setUserVideo(5, 4);
            }


            const setFrameButtons = () => {
                const btnContainer = document.querySelector('.pageBootcampModules__content__video');
                const btnEnd = document.querySelector('#video_bootcamp1_modulo5_video4 .btnModule');
                const backBtn = document.createElement('button');
                const nextBtn = document.createElement('button');
                backBtn.classList.add('backButton');
                backBtn.innerHTML = 'ANTERIOR'
                backBtn.setAttribute('videoPoint', `bootcamp1_modulo${currentModule}_video4`);
                backBtn.id = 'backVideo';
                backBtn.addEventListener('click', () => {
                    backLastVideo();
                    setModuleTitle(currentModule);
                    if (btnContainer.querySelector('#nextBtn') != null) {
                        btnContainer.removeChild(nextBtn);
                    }
                    btnEnd.style.display = 'block';
                    btnContainer.removeChild(backBtn);
                });
                btnEnd.style.display = 'none';
                btnContainer.appendChild(backBtn);
            }

            const submitData = (btn) => {
                const btnModule = btn.getAttribute('idCurrentVideo');
                const btnListId = btn.getAttribute('listId');
                const formData = new FormData();
                formData.append('action', 'bootcamp_register_view');
                formData.append('module', btnModule);
                formData.append('listId', btnListId);
                formData.append('email', menuUserEmail);
                loaderPage.classList.add('visible');

                fetch(url, {
                    method: "POST",
                    credentials: "same-origin",
                    body: formData,
                }).then(() => {
                    loaderPage.classList.remove('visible');
                });
            }

            const setModuleTitle = (currentModule) => {
                const titleContainer = document.querySelector('.pageBootcampModules__content__title');
                titleContainer.innerHTML = modules[currentModule].moduleTitle;
            }

            const changeVideo = (btn) => {
                loaderPage.classList.add('visible');

                endYoutubeVideo(document.querySelectorAll('.playerIframe'));

                const btnAttr = btn.getAttribute('videopoint');

                if (btn.classList.contains('btnModule')) {
                    submitData(btn);
                }

                if (btnAttr != 'endLast') {
                    currentModule = _searchInString(btnAttr, 'modulo');
                    currentVideo = _searchInString(btnAttr, 'video');
                    setModuleTitle(currentModule);
                } else {
                    setTextFrame();
                    setFrameButtons();
                }

                setUserVideo(currentModule, currentVideo);
                setMenuProperties(currentModule, currentVideo);
                setModulesProperties(currentModule);
                _generateFlickity
                loaderPage.classList.remove('visible');

            }


            const submitCertificate = (e) => {
                e.preventDefault();
                const formData = new FormData(certificateForm);
                let fullname = formData.get('fullname');
                let today = new Date();
                let dd = String(today.getDate()).padStart(2, '0');
                let mm = String(today.getMonth() + 1).padStart(2, '0');
                let yyyy = today.getFullYear();
                let date = dd + '/' + mm + '/' + yyyy;
                forceDownload(fullname, date);
            }

            const forceDownload = (name, date) => {
                var xhr = new XMLHttpRequest(),
                    encodeName = encodeURI(name),
                    encodeDate = encodeURI(date),
                    domainUrl = (local_object.is_prod == '1') ? 'certificate-bootcamp.php' : 'certificate-bootcampqa.php',
                    url = 'https://textify.fromdoppler.com/' + domainUrl + '?name=' + encodeName + '&course=%20Complet%C3%B3%20la%20Certificaci%C3%B3n%20en%20Automation%20Marketing%20de%20Doppler%20Digital%20Bootcamp,&date=%20el%20d%C3%ADa ' + encodeDate,
                    fileName = 'certificacion-bootcamp.png';


                xhr.open("GET", url, true);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    var tag = document.createElement('a');
                    tag.href = imageUrl;
                    tag.download = fileName;
                    document.body.appendChild(tag);
                    tag.click();
                    document.body.removeChild(tag);
                }
                xhr.send();
                document.querySelector('.modalCertificateContainer').classList.add('ac-none');
            }


        } else {
            notLogedWarning.parentNode.classList.add('showCurrentVideo');

            const _closeModules = () => {
                document.querySelectorAll('.module').forEach(item => item.classList.remove('pageBootcampModules__sidebar__module--opened'))
            }

            _closeModules();

        }
    }
});
